export default {
  section: {
    marginBottom: '20px'
  }
};